export default __webpack_public_path__ + "static/media/coco_image.561cdbf7.svg";